/**
 * data-ui-max-items 属性から最大表示件数を取得する
 * @returns 0 = 無制限
 */
export const parseMaxItems = (root: HTMLElement): number => {
  const val = root?.dataset?.uiMaxItems;
  if (!val) return 0;
  const n = parseInt(val, 10);
  return isNaN(n) || n <= 0 ? 0 : n;
};
